let modals = require( './modals' );

let manage_billing_contacts_table = function( $ ) {

	let $table,
		$remove_popup,
		anim_speed = 400;

	let _init = function() {
		$table = $( '#manage-billing-contacts-table table' );

		if ( $table.length > 0 ) {
			$remove_popup = $( '#practice-account-remove-billing-contact-popup' );

			_setup_edit_toggles();
			_setup_remove_billing_contact();
			_added_contact_messages();
		}
	};

	let _setup_remove_billing_contact = function() {
		$( '#remove-billing-contact-button' ).on( 'click', function( e ) {
			e.preventDefault();

			_remove_billing_contact( $( this ).attr( 'data-billing-contact-id' ) );
		} )
	};

	let _setup_edit_toggles = function() {
		$table.find( '.edit-actions' ).each( ( index, item ) => {
			let $item = $( item );

			_setup_edit_action( $item );
			_setup_edit_action_links( $item );
		} );

		$( '#content' ).on( 'click', _close_content_click );
	};

	let _setup_edit_action_links = function( $container ) {
		$container.find( 'a.remove-billing-contact' ).on( 'click', function( e ) {
			e.preventDefault();

			let billing_contact_id = $( this ).closest( 'tr' ).data( 'billing-contact-id' ),
				email              = $( this ).closest( 'tr' ).data( 'email' );

			_update_remove_popup( billing_contact_id, email );
		} );
	};

	let _added_contact_messages = function() {
		let query_strings = $.getQueryParameters();

		if ( ! query_strings.email ) {
			return;
		}

		let data = {
			nonce: ScriptData.crate_practice_added_billing_contacts_messages_nonce,
			action: 'crate_get_billing_contacts_added_messages',
			contacts: query_strings.email,
		};

		$.post( ScriptData.ajaxurl, data, ( response ) => {
			if ( response.notices ) {
				// Remove added contacts query string from history
				history.pushState( null, '', location.href.split( '?' )[0] );

				$.each( response.notices, ( index, item ) => {
					_add_notice( 'success added-billing-contact', item, false );
				} );
			}
		} );
	};

	let _update_remove_popup = function( billing_contact_id, email ) {
		$remove_popup.find( '.modal-title .email-address' ).text( email );
		$( '#remove-billing-contact-button' ).attr( 'data-billing-contact-id', billing_contact_id );
	};

	let _setup_edit_action = function( $container ) {
		$container.find( 'a.toggle-actions' ).on( 'click', function( e ) {
			e.preventDefault();

			_toggle_actions( $container );
		} );
	};

	let _toggle_actions = function( $container ) {
		if ( $container.hasClass( 'animating' ) ) {
			return;
		}

		$container.addClass( 'animating' );

		if ( $container.hasClass( 'open' ) ) {
			_close_animation( $container.find( '.action-links' ) );
		} else {
			_open_animation( $container.find( '.action-links' ) );
		}

		setTimeout( () =>  {
			$container.removeClass( 'animating' );
		}, anim_speed );
	};

	let _close_content_click = function( e ) {
		if ( ! e.target.matches( '.edit-actions, .edit-actions *' ) ) {
			$table.find( '.edit-actions' ).each( ( index, item ) => {
				_close_animation( $( item ).find( '.action-links' ) );
			} );
		}
	};

	let _open_animation = function( $elem ) {
		$elem.closest( '.edit-actions' ).addClass( 'open' );
		$elem.closest( '.edit-actions' ).removeClass( 'closed' );

		$elem.fadeIn( anim_speed );
	};

	let _close_animation = function( $elem ) {
		$elem.closest( '.edit-actions' ).addClass( 'closed' );
		$elem.closest( '.edit-actions' ).removeClass( 'open' );

		$elem.fadeOut( anim_speed );
	};

	let _remove_billing_contact = function( billing_contact_id ) {
		$table.loading();

		let  data = {
			nonce: ScriptData.crate_practice_remove_billing_contact_nonce,
			action: 'crate_practice_remove_billing_contact',
			billing_contact_id: billing_contact_id
		};

		$.post( ScriptData.ajaxurl, data, ( response ) => {
			$table.loaded();

			if ( response.success ) {
				update_table_html();

				if ( response.message ) {
					_add_notice( 'success', response.message );
				}
			} else {

				if ( response.error ) {
					_add_notice( 'error', response.error );
				}
			}
		} );
	};

	let update_table_html = function() {
		$table.loading();

		let data = {
			nonce: ScriptData.crate_practice_get_billing_contacts_table_html_nonce,
			action: 'crate_get_billing_contacts_table_html'
		};

		$.post( ScriptData.ajaxurl, data, ( response ) => {
			if ( response.success ) {
				$table.closest( '.billing-contacts-table-wrapper' ).replaceWith( response.html );

				// update global table element
				$table = $( '#manage-billing-contacts-table table' );

				_setup_edit_toggles();
				modals.init();

				$( '#manage-billing-contacts-table' ).trigger( 'updated_table_html' );
			} else {
				// Error retrieving html so refresh page
				window.location.reload();
			}

			$table.loaded();
		} );
	};

	let _add_notice = function( type, message, hide_all = true ) {
		let $wrapper = $( '#manage-billing-contacts-table' ).find( '.notices' );

		if ( hide_all ) {
			$wrapper.find( '.notice' ).slideUp( anim_speed );
		}

		$wrapper.append( '<div style="display: none" class="notice ' + type + ' new-notice">' + message + '<a href="#" class="close-popup"></a></div>' ).append( () => {
			$wrapper.find( '.notice .close-popup' ).on( 'click', function( e ) {
				e.preventDefault();

				$( this ).closest( '.notice' ).slideUp( anim_speed );

				setTimeout( () => {
					$( this ).closest( '.notice' ).remove();
				}, anim_speed )
			} );
		});

		$wrapper.find( '.notice.new-notice' ).slideDown( anim_speed );
		$wrapper.find( '.notice.new-notice' ). removeClass( 'new-notice' );
	};

	$( document ).ready( _init );

	return {
		update_table_html: update_table_html
	}

} ( jQuery );

module.exports = manage_billing_contacts_table;